<template>
  <div class="random-interview relative bg-white" style="height: 100%">
    <!-- 【添加调查员】和【去任务广场招募】按钮 -->
    <div class="absolute right-4 z-10 ml-3 mt-2" v-show="flag">
      <el-button type="primary" @click="addInterviewer">分配调查员</el-button>
    </div>
    <!-- 下面的表格 -->
    <div class="basic-content bg-white pb-3 relative">
      <!-- 选中的调查员表格 -->
      <selected-interviewer
        class="mt-4"
        :inputPlaceholder="inputPlaceholderOptions"
        :taskStatus="taskStatusOptions"
        :tableColumnName="tableColumnNameOptions"
        :propTableData="tableData"
        :combineField="combineFieldOptions"
        @inputValueChange="getTableData"
        :switchChangeFunc="putOfflineTask"
        :parseParamsFunc="parseParams"
        :successFunc="successHandler"
        :newField="newFieldOptions"
        :addArrangeParams="addArrangeParamsHandler"
        :createTaskFunc="plCreat"
        channel="randomInterviewer"
        :total="total"
        :searchRight="false"
        @flag="getflag"
        @setTask="getLoadData"
        tableType="taskTable"
        :proxyType="1"
        :isShowRightAdv="1"
      />
    </div>
    <el-drawer
      title="添加调查员"
      :visible.sync="addDrawer"
      direction="rtl"
      size="70%"
      :destroy-on-close="true"
      :before-close="handleAddDrawerClose"
    >
      <div class="main-box w-full box-border">
        <AddInterviewer :proxyType="1" @close="handleAddDrawerClose" @emitDialog="changeOverDialog"></AddInterviewer>
      </div>
    </el-drawer>
    <el-drawer
      title="任务广场招募调查员"
      :visible.sync="recruitDrawer"
      size="70%"
      :destroy-on-close="true"
      :before-close="handleRecruitDrawerClose"
    >
      <RecruitmentForm
        @cancel="handleRecruitDrawerClose"
        :surveyId="GlobalConfig.getSurveyId()"
        :pageType="'visitor'"
      ></RecruitmentForm>
    </el-drawer>
    <over-mask
      :dialogVisible="dialogVisible"
      @handleClose="
        () => {
          dialogVisible = false
        }
      "
    ></over-mask>
  </div>
</template>

<script>
import selectedInterviewer from '@/views/survey/offline/components/SelectedInterviewer.vue'
import signupInterviewer from '@/views/survey/offline/components/SignupInterviewer.vue'
import AddInterviewer from '@/views/survey/offline/components/AddInterviewer.vue'
import RecruitmentForm from '@/views/survey/offline/components/RecruitmentForm.vue'
import {
  getRecruitTaskList,
  getRandomInterviewTableData,
  putOfflineTask,
  getEntrustInterviewTableData
} from '@/api/wenjuan/offline.js'
import {
  inputPlaceholderOptions,
  taskStatusOptions,
  taskStatusOptionsInvestment,
  tableColumnNameOptions,
  dialogData,
  newFieldOptions
} from '@/views/survey/offline/options/index.js'
import { plCreat } from '@/api/wenjuan/addList.js'
import GlobalConfig from '@/global/config'
import OverMask from '@/views/survey/offline/components/overMask/OverMask.vue'
import { toTaskSquare } from '@/assets/js/base-platform.js'
import { getStore } from '@dygc/shared'
export default {
  name: 'random-interview',
  components: {
    selectedInterviewer,
    signupInterviewer,
    AddInterviewer,
    RecruitmentForm,
    OverMask
  },
  data() {
    return {
      GlobalConfig,
      addDrawer: false,
      recruitDrawer: false,
      activeIndex: '1',
      handlerSum: '',
      guideDialog: false,
      dialogData: [],
      // 输入框提示语 提供给共通组件配置
      inputPlaceholderOptions: {},
      // 可选的任务状态配置
      taskStatusOptions: [],
      // 表格列名配置
      tableColumnNameOptions: {},

      tableData: [], // 获取到的 table 的数据
      // 按照什么字段合并
      combineFieldOptions: {
        name: 'executorName',
        concat: 'executorPhone',
        id: 'id'
      },
      putOfflineTask: new Function(),
      newFieldOptions: {},
      plCreat: new Function(),
      total: 0,
      isShowGuide: false,
      dialogVisible: false,
      flag: true
    }
  },
  watch: {
    '$route.query.taskId': function (val) {
      console.log(val)
      if (val) {
        this.getTableData()
      }
    }
  },
  methods: {
    getflag(v) {
      this.flag = v
    },
    handleSelect(index) {
      // string: 1 / 2
      index == 1 && this.getTableData()
      this.activeIndex = index
    },
    addInterviewer() {
      this.addDrawer = true
    },
    handleAddDrawerClose() {
      this.init()
      this.getTableData()
      this.addDrawer = false
    },
    recuitment() {
      toTaskSquare()
      // this.recruitDrawer = true
      //this.$router.push(`/survey/${GlobalConfig.getSurveyId()}/offline/random-interview/recruit`)
    },
    handleRecruitDrawerClose() {
      this.recruitDrawer = false
    },
    // 【未处理数】的处理函数
    handlerSumHandler(handlerSum) {
      // console.log('handlerSum: ', handlerSum);
      this.handlerSum = handlerSum
    },

    // 获取表格数据的方法 如果传入了 params，就用传入的 没传入就用 defaultParams
    getTableData(temParams) {
      let defaultParams = {
        surveyId: GlobalConfig.getSurveyId(),
        entrustTaskId: this.$route.query.taskId || getStore({ name: 'taskId' }),
        current: 1,
        size: 20
      }
      let params = Object.assign({}, defaultParams)
      if (temParams) {
        temParams.commonName && (params.executorName = temParams.commonName)
        temParams.commonPhone && (params.executorPhone = temParams.commonPhone)
        temParams.commonTaskName && (params.executionName = temParams.commonTaskName)
        temParams.taskStatusValue && (params.status = temParams.taskStatusValue)
        params.current = temParams.current
      }

      // getRandomInterviewTableData(params)
      getEntrustInterviewTableData(params)
        .then(res => {
          // this.guideDialog = res.data.data.records.length == 0 ? true : false;
          this.isShowGuide = res.data.data.records.length == 0 ? true : false
          // this.tableData = res.data.data.records;
          this.total = res.data.data.total

          // 处理数据
          // 在每条数据上加上 show 和 edit 字段 之后表格操作会用到
          this.tableData = res.data.data.records.map(item => {
            // 模拟数据

            // item.settleMode = 1;
            // item.settleRule ={
            //   "tiers": [
            //     {
            //       "unitPriceYuan": 10,
            //       "quantityLowerBound": 1,
            //       "quantityUpperBound": 100
            //     },
            //     {
            //       "unitPriceYuan": 20,
            //       "quantityLowerBound": 101,
            //       "quantityUpperBound": 200
            //     },
            //     {
            //       "unitPriceYuan": 30,
            //       "quantityLowerBound": 201,
            //       "quantityUpperBound": 300
            //     }
            //   ],
            //   "unitPriceYuan": 1,
            //   "expectedQuantity": 1
            //   }

            // 新增的两个字段
            item.show = false
            item.edit = true

            // 修改字段 变成组件统一的 prop
            item.equalName = item.executorName
            item.equalPhone = item.executorPhone
            item.equalTaskName = item.executionName
            item.equalState = item.status
            item.equalTaskEndTime = item.executionValidateTo
            item.equalCount = item.executionQuantity
            item.equalPrice = item.executionSingleAmount
            item.equalCommitCount = item.recycledQuantity
            item.equalEffectiveCount = item.effectiveQuantity

            if (item.status == 7 || item.status == 8) {
              item.isOpen = false
            } else {
              item.isOpen = true
            }
            return item
          })
          this.handleTableData(this.tableData, 'executorPhone')
        })
        .catch(e => {
          this.$message.error('获取数据失败')
          console.log(e.message)
        })
    },
    handleTableData(dataList, colName) {
      // 需要去重的数组
      let repeatField = []
      dataList.forEach(item => {
        repeatField.push(item[colName])
      })
      repeatField = [...new Set(repeatField)]
      dataList.forEach((it, i, arr) => {
        repeatField.forEach(itField => {
          if (itField === it[colName]) {
            it.rowspan = arr.filter(itemFilter => itemFilter[colName] === itField).length
          }
        })
      })
      console.log(dataList)
    },
    parseParams(row) {
      let status = row.isOpen ? 6 : 7
      if (row.status === 8) {
        return
      }
      return { id: row.id, status }
    },

    successHandler(row) {
      let status = row.isOpen ? 6 : 7
      row.status = status
    },
    // 新增项的参数处理
    addArrangeParamsHandler(data) {
      return [
        {
          surveyId: GlobalConfig.getSurveyId(),
          executorName: data.equalName,
          executorPhone: data.equalPhone,
          userName: data.equalName,

          executionName: data.equalTaskName,
          executionValidateTo: data.equalTaskEndTime,
          executionQuantity: data.equalCount,
          executionSingleAmount: data.equalPrice,
          recycledQuantity: '',
          effectiveQuantity: '',
          executionDescription: ''
        }
      ]
    },
    // 从配置文件中初始化一些东西
    init() {
      // 将在配置文件中导入的东西进行初始化
      this.inputPlaceholderOptions = inputPlaceholderOptions
      // this.taskStatusOptions = taskStatusOptions

      this.taskStatusOptions = taskStatusOptionsInvestment

      this.tableColumnNameOptions = tableColumnNameOptions
      this.dialogData = dialogData
      this.newFieldOptions = newFieldOptions
    },
    // 从配置文件中初始化一些东西
    // init() {
    //   // 将在配置文件中导入的东西进行初始化
    //   this.inputPlaceholderOptions = inputPlaceholderOptions;
    //   this.taskStatusOptions = taskStatusOptions;
    //   this.tableColumnNameOptions = tableColumnNameOptions;
    //   this.dialogData = dialogData;
    //   this.putOfflineTask = putOfflineTask;
    //   this.newFieldOptions = newFieldOptions;
    //   this.plCreat = plCreat;
    // }
    getLoadData(val) {
      console.log('getLoadData', val)
    },
    changeOverDialog(val) {
      this.dialogVisible = val
    }
  },
  async created() {
    this.init()
    this.getTableData()
    let res = await getRecruitTaskList({
      surveyId: GlobalConfig.getSurveyId()
    })
    let count = 0
    res.data.data &&
      res.data.data.forEach(item => {
        item.interviewerList.forEach(n => {
          if (n.shopHasProxyJobStatus == 100) {
            count++
          }
        })
      })
    this.handlerSum = count == 0 ? '' : count
    // this.handlerSum = count;
    this.putOfflineTask = putOfflineTask
    this.plCreat = plCreat
    //this.init()
    this.guideDialog = this.isShowGuide
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-table th.el-table__cell > .cell,
  .el-table .cell {
    padding-left: 6px;
    padding-right: 6px;
  }
}
.random-interview {
  .banner {
    img {
      width: 100%;
      height: 100%;
    }
  }
  .el-menu--horizontal > .el-menu-item.is-active {
    @apply text-theme;
  }
  ::v-deep .el-badge__content.is-fixed {
    position: absolute;
    top: 4px;
    right: 2px;
  }
  ::v-deep .el-badge__content {
    height: 18px;
    line-height: 16px;
  }
  .el-menu--horizontal {
    height: 46px;
    .el-menu-item {
      height: 46px;
    }
    .el-badge {
      line-height: 29px;
      height: 46px;
    }
  }
  .absolute {
    right: 12px;
    position: absolute;
    top: 8px;
    width: 300px;
    text-align: right;
  }
  .basic-content {
    ::v-deep .el-card__body {
      min-height: calc(100vh - 350px) !important;
    }
    overflow: hidden;
  }

  .promptDialog {
    width: 100%;
    height: 70vh;
    h1 {
      text-align: center;
      color: #000;
      margin: 0;
    }
    .content {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      .items {
        width: 25%;
        height: 120px;
        box-shadow: 0px 0px 5px 2px #eee;
        margin: 20px 2.1%;
        padding: 2%;
        border-radius: 5px;
        h3 {
          color: #000;
          font-size: 18px;
        }
        p {
          color: rgb(141, 141, 141);
          font-size: 16px;
          margin-top: 10px;
          font-weight: 500;
        }
      }
    }
  }
}
</style>
